import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import i18next from 'i18next';
import * as crypto from 'node:crypto';
import { SUPPORTED_LANGUAGES } from '../../i18n.js';
import { Conversation } from '../conversation.js';
import { Exam, initializeExamState } from '../exam.js';

export const createExamMutation = registerMutation({
  operationName: 'createExamMutation',
  type: () => Conversation,
  params: [
    { name: 'language', type: () => String },
    { name: 'guestUserID', type: () => String },
  ],

  resolve:
    (language = 'de', guestUserID?: string) =>
    async (_gqlFields: BaseQLSelectionSet<Conversation>) => {
      const examId = crypto.randomUUID();
      const conversationId = crypto.randomUUID();

      const now = new Date();
      const timestamp = now.toISOString();
      const resolvedLanguage = typeof language === 'string' && language.trim().length > 0 ? language : 'de';

      const baseExamTitle = i18next.t('Sidebar.examList.unnamedExam', { lng: resolvedLanguage });
      const examDate = new Intl.DateTimeFormat(resolvedLanguage, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(now);
      const examTitle = `${baseExamTitle} ${examDate}`;
      logger.info({ examTitle, resolvedLanguage }, 'Creating new exam with title');
      // Get the currently logged-in user to set ownership
      const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
      const userID = currentUser?._id || guestUserID || null;

      const exam = new Exam({
        _id: examId,
        //   title,
        //   teacher,
        //   schoolClass: className,
        //   school,
        //   subject,
        title: examTitle,
        createdAt: timestamp,
        status: 'created',
        conversationId,
        examState: initializeExamState(examId),
        totalCost: 0,
        userID, // Set the owner from the current session
      });

      const conversation = new Conversation({
        _id: conversationId,
        thinking: false,
        language: SUPPORTED_LANGUAGES.find(entry => entry.value === resolvedLanguage)?.label || 'Deutsch',
        messages: [
          // new AssistantMessage({
          //     content: `Hallo! Die Klausur "${title}" wurde angelegt. Bitte lade jetzt die PDF hoch.`
          // }).toObject()
        ],
        examId, // Perfekt verlinkt
        userID, // Set the owner from the current session
      });

      const examCollection = await getCollection(Exam);
      const conversationCollection = await getCollection(Conversation);

      await examCollection.insertOne(exam.toObject());
      await conversationCollection.insertOne(conversation.toObject());

      // Return the created Conversation entity (BaseQL will handle selection)
      return conversation;
    },
});
